import React, {Component} from 'react';
import {Nav, NavItem} from 'reactstrap';
import {NavLink} from 'react-router-dom';

export class SecondaryNavigation extends Component {
    render() {
        const {id, vertical, hr} = this.props;
        return (
            <Nav vertical={vertical} className="mt-3">
                <NavItem>
                    <NavLink className="nav-link" to={`/customer/${id}`} isActive={(p) => p && p.url === window.location.pathname}>
                        Stammdaten
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink className="nav-link" to={`/customer/${id}/contacts`}>
                        Ansprechpartner
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink className="nav-link" to={`/customer/${id}/locations`}>
                        Standorte
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink className="nav-link" to={`/customer/${id}/notes`}>
                        Sonderinformationen
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink className="nav-link" to={`/customer/${id}/parameters`}>
                        Eckdaten
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink className="nav-link" to={`/customer/${id}/zones`}>
                        Bereichsdaten
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink className="nav-link" to={`/customer/${id}/employees`}>
                        Mitarbeiterdaten
                    </NavLink>
                </NavItem>

                <NavItem>
                    <NavLink className="nav-link" to={`/customer/${id}/numbers`}>
                        Zahlen
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink className="nav-link" to={`/customer/${id}/time_sheets`}>
                        Stunden
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink className="nav-link" to={`/customer/${id}/work`}>
                        Geleistete Arbeit
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink className="nav-link" to={`/customer/${id}/manuals`}>
                        Betriebsanweisungen
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink className="nav-link" to={`/customer/${id}/templates`}>
                        Mustervorlagen
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink className="nav-link" to={`/customer/${id}/training`}>
                        Schulungen
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink className="nav-link" to={`/customer/${id}/invoices`}>
                        Rechnungen
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink className="nav-link" to={`/customer/${id}/uploads`}>
                        Zusätzlicher Upload
                    </NavLink>
                </NavItem>
                { hr &&
                    <hr/>
                }
                <NavItem>
                    <NavLink className="nav-link" to={`/customer/${id}/reports`}>
                        Berichte
                    </NavLink>
                </NavItem>
            </Nav>
        )
    }
}
